import React, { useState } from 'react';

import type { BulkEmailDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';

import Card from '../../../components/common/Card';
import BulkEmailForm from '../../../components/forms/BulkEmailForm';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useBulkEmailApi } from '../../../hooks/useBulkEmailApi';

const BulkEmailCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialValues, setInitialValues] = useState<BulkEmailDTO>({});
  const [attachmentFile, setAttachmentFile] = useState<File | null>(null);
  const navigate = useNavigate();
  const { uploadBulkEmailAttachment, create } = useBulkEmailApi();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Bulk Emails', href: '/admin/bulkemails' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: BulkEmailDTO): Promise<void> => {
    setIsSubmitting(true);
    try {
      let updatedValues = { ...data };

      if (attachmentFile) {
        const response = await uploadBulkEmailAttachment(
          attachmentFile.name,
          attachmentFile,
        );
        if (response && response.success && response.data) {
          updatedValues = { ...updatedValues, fileRecordId: response.data };
        }
      }

      // Custom list file is uploaded in the form; strip the sentinel value before saving
      if (updatedValues.communicationListId === '__custom_upload__') {
        updatedValues = { ...updatedValues, communicationListId: undefined };
      }

      await create(updatedValues);
      navigate('/admin/bulkemails');
    } catch (error) {
      console.error('Error creating bulk email:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/bulkemails"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
    >
        <BulkEmailForm
          initialValues={initialValues}
          isSubmitting={isSubmitting}
          setInitialValues={setInitialValues}
          setAttachmentFile={setAttachmentFile}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/bulkemails')}
        />
    </AdminLayout>
  );
};

export default BulkEmailCreate;
